export enum OrderWorkflowStep {
  patientData = 'patient_data',
  productConfiguration = 'product_configuration',
  deliveryReturnDate = 'delivery_return_date',
  summary = 'summary',
}
